<template>
    <div class="comment-badge">
        <div class="comment-badge-image">
            <i class="mdi mdi-account"></i>
        </div>
        <div class="mb-2">
            <div class="comment-body mb-2" >
                <div class="comment-body-header row m-0 mb-3 mb-lg-0 mb-lx-0">
                    <p class="col-12 col-lg-6 col-lx-6 p-0 text-start">{{ name }}</p>
                    <p class="col-12 col-lg-6 col-lx-6 p-0 text-start text-lg-right text-xl-right">{{ relativeTime }}</p>
                </div>
                <p class="comment-body-text" v-html="body.replace(/\n/g, '<br>')">
                </p>
            </div>
            <!-- <div class="comment-footer">
                <div class="mr-5"> 
                    <FlatIconButton label="Share" icon="mdi mdi-share-variant"/>
                </div> 
                <div class="mr-5"> 
                    <FlatIconButton label="Like" icon="mdi mdi-thumb-up" />
                </div>
            </div> -->
        </div>
        
    </div>
</template>

<script>
import FlatIconButton from '../buttons/flat-icon-button.vue';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(utc);
dayjs.extend(relativeTime);

export default {
    name: "comment-badge",
    components: {
        FlatIconButton
    },
    props: [
        "id",
        "name",
        "photo",
        "body",
        "date",
        "likes",
        "shares"
    ],
    computed: {
        relativeTime: function() {
            return dayjs.utc(this.date).fromNow();
        }
    }
}
</script>

<style>
.comment-badge {
    margin-bottom: 15px;
    display: flex;
}

.comment-badge > div:last-of-type {
    width: 100%;
}

.comment-badge-image {
    height: 66px;
    width: 66px;
    border-radius: 33px;
    background: linear-gradient(180deg, rgba(163,163,163,1) 0%, rgba(134,134,134,1) 100%);
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
}

.comment-badge-image i {
    font-size: 40px;
    color: #0000003c;
}

.comment-body {
    background-color: #F5F5F5;
    padding: 10px;
}

.comment-body-header p {
    margin: 0;
}

.comment-body-header p:first-of-type {
    font-size: 18px;
    font-weight: bold;
    color: black;
}

.comment-body-header p:last-of-type {
    font-size: 16px;
    color: black;
}

.comment-body-text {
    font-size: 16px;
    margin: 0;
}

.comment-footer {
    display: flex;
}

</style>